import React from 'react';
import { BucketKind } from '../../../../../utils/apollo/graphqlSchema';
import { IBasicBinning } from '../../../../../redux/slices/oldBuilder/binning/types';
import BasicBucketDefHeader from './BucketDefHeader';
import { AutoRangeBuckets, ManualRangeBuckets } from './RangeBuckets';
import { EnumBuckets, GroupOthersToggle } from './EnumBuckets';
import { isNil } from 'lodash';

interface IProps {
  basicBinning: IBasicBinning;
  groupIndex?: number;
}

export default ({ basicBinning, groupIndex }: IProps) => (
  <>
    <BasicBucketDefHeader binning={basicBinning} groupIndex={groupIndex} />
    {/* display the buckets by selected bucket kind */}
    {basicBinning.kind === BucketKind.Range &&
      !basicBinning.isAutoRangeBucket && (
        <ManualRangeBuckets binning={basicBinning} groupIndex={groupIndex} />
      )}
    {basicBinning.kind === BucketKind.Range &&
      basicBinning.isAutoRangeBucket && (
        <AutoRangeBuckets binning={basicBinning} groupIndex={groupIndex} />
      )}
    {basicBinning.kind === BucketKind.Enum && (
      <EnumBuckets binning={basicBinning} groupIndex={groupIndex} />
    )}
    {/* only make sense for breakdown for splitting others */}
    {basicBinning.kind === BucketKind.Enum && !isNil(groupIndex) && (
      <GroupOthersToggle binning={basicBinning} groupIndex={groupIndex} />
    )}
  </>
);
